<template>
    <section class="section section-white section-details">
        <div class="container">
            <h2
                class="text-center"
                v-html="$t('home.comprehensiveMaterial')">
            </h2>

            <div class="row">
                <div class="col-md-4 mb-4 mb-md-0">
                    <a
                        href="#section-pricing"
                        class="unit unit-red text-decoration-none"
                        :title="$t('auth.viewPricing')"
                    >
                        <div class="content">
                            <img
                                src="images/icons/cart.svg"
                                class="icon"
                                alt="Cart icon"
                            >

                            <h4>
                                {{ $t('auth.subscribeToPlan') }}
                            </h4>

                            <p>
                                {{ $t('home.subscribeAffordablePlan') }}
                            </p>
                        </div>

                        <span>
                          {{ $t('auth.viewPricing') }}
                        </span>
                    </a>
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                    <router-link
                        to="/material"
                        class="unit unit-yellow text-decoration-none"
                        :title="$t('home.showMe')"
                    >
                        <div class="content">
                            <img
                                src="images/icons/clipboard.svg"
                                class="icon"
                                alt="Clipboard icon"
                            >

                            <h4>
                                {{ $t('home.selectATeachingSeries') }}
                            </h4>

                            <p>
                                {{ $t('home.chooseFromFor', [40]) }}
                            </p>
                        </div>

                        <span>
                          {{ $t('home.showMe') }}
                        </span>
                    </router-link>
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                    <router-link
                        to="/samples"
                        class="unit unit-blue text-decoration-none"
                        :title="$t('auth.viewSampleMaterial')"
                    >
                        <div class="content">
                            <img
                                src="images/icons/eye.svg"
                                class="icon"
                                alt="Cart icon"
                            >

                            <h4>
                                {{ $t('home.viewTheLesson') }}
                            </h4>

                            <p>
                                {{ $t('home.selectALanguageThenDownload') }}
                            </p>
                        </div>

                        <span>
                          {{ $t('auth.viewSampleMaterial') }}
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Features",
};
</script>
